import { isNil } from "@hopper-ui/components";
import { MixpanelEventName, MixpanelProperty } from "@sg-protect/shell";
import type { DOMEventTelemetryHandler } from "./domEventTracker.ts";
import { getClosestRole, getModalInformation, getTelemetryName } from "./utils.ts";

export const dropdownItemClickHandler: DOMEventTelemetryHandler<"click"> = {
    isHandling: evt => {
        return !isNil(evt.target) && actsAsDropdownItem(evt.target as HTMLElement);
    },
    handleEvent: (evt, onEvent) => {
        const item = evt.target as HTMLElement;

        let text = "";
        try {
            text = getDropdownItemName(item) || "Redacted";
        } catch {
            text = getTelemetryName(item) || "Redacted";
        }

        const modalInformation = getModalInformation(item);
        const dropdownTitle = getDropdownTitle(item);

        void onEvent(MixpanelEventName.MenuItemClicked, {
            [MixpanelProperty.Name]: `${dropdownTitle} - ${text}`,
            [MixpanelProperty.Modal]: modalInformation
        });
    }
};

function actsAsDropdownItem(element: HTMLElement) {
    return !!getClosestRole(element, "option");
}

function getDropdownTitle(element: HTMLElement) {
    const menu = getClosestRole(element, "listbox");

    return getTelemetryName(menu);
}

function getDropdownItemName(element: HTMLElement) {
    const item = getClosestRole(element, "option");

    return getTelemetryName(item);
}
